import Vue from 'vue'

const defaultUser = {
  id: null,
  first_name: null,
  last_name: null,
  email: null,
  is_superuser: false,
  company: null,
  member_id: null,
  report_id: null,
  profile_photo: '',
  device_2fa_enabled: false,
  type: 'Guest',
  role: 'Guest'
}

const state = {
  user: defaultUser,
  authenticating: false,
  loggedin_magiclink: false,
  request_access_email: null
}

const getters = {
  user: (state) => {
    const user = state.user

    if (state.user.is_superuser) {
      user.company_assigned = true
    }

    return user
  },
  user_type(state) {
    let type = state.user.type
    type = state.user.is_superuser ? 'Superuser' : type

    return type
  },
  authenticated: (state, getters) => {
    return !!getters.accessToken && state.user.id !== null
  },
  authenticating: (state) => state.authenticating,
  loggedin_magiclink: (state) => state.loggedin_magiclink,
  request_access_email: (state) => state.request_access_email,
  hasFCPAccess: (state) => {
    if (state.user.is_superuser) return true

    return !!state.user.company
  }
}

const actions = {
  setUser({ commit }, newUser) {
    commit('SET_USER', newUser)
  }
}

const mutations = {
  SET_USER: (state, newUser) => {
    if (!!newUser) {
      state.user = {
        ...state.user,
        ...newUser,
        role: newUser.is_superuser ? 'Superuser' : newUser.type
      }
    } else {
      state.user = defaultUser
    }

    Vue.prototype.$user.set(state.user)
  },
  AUTH_LOGIN_MAGICLINK: (state, payload) => {
    state.loggedin_magiclink = payload
  },
  AUTH_SET_DEFAULT_REPORT: (state, payload) => {
    state.user.report_id = payload.data.report_id
  },
  AUTH_SET_REQUEST_ACCESS_EMAIL: (state, payload) => {
    state.request_access_email = payload
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
